



























































































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import ReportModule from '@/store/modules/Report';
import AuthModule from '@/store/modules/Auth';
import GameModule from '@/store/modules/Game';
import Table from '@/components/Table/Index.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import MemberBody from '@/components/Table/MemberBody.vue';
import LogBody from '@/components/Table/LogBody.vue';
import Pagination from '@/components/Pagination.vue';
import WinLoseData from '@/data/WinLoseData';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import PaginationMixin from '@/mixins/Pagination.vue';
import DateRangeLogBody from '@/components/Table/DateRangeLog.vue';
import NewMemberBody from '@/components/Table/NewMemberBody.vue';
import MechanicModule from '@/store/modules/Mechanic';

@Component({
  components: {
    Table,
    Breadcrumb,
    Pagination,
    MemberBody,
    LogBody,
    NewMemberBody,
    DateRangeLogBody,
  },
})
export default class WinLoseMemberView extends Mixins(
  ToolMixin,
  ErrorHandleMixin,
  PaginationMixin,
) {
  ReportInstance = getModule(ReportModule, this.$store);

  AuthInstance = getModule(AuthModule, this.$store);

  GameInstance = getModule(GameModule, this.$store);

  MechanicInstance = getModule(MechanicModule, this.$store);

  Criteria = {
    ...this.Period,
    isSearch: false,
    gameName: ['total'],
    products: ['total'],
    role: this.AuthInstance.user.role,
    userId: this.AuthInstance.user._id,
    username: this.AuthInstance.user.username,
    source: this.AuthInstance.user.source,
    id: this.AuthInstance.user._id,
    sort: 'turnover',
  };

  DefaultPatternList = [
    {
      name: 'All',
      value: 'total',
    },
  ];

  sortList = ['turnover', 'agent'];

  PatternList: any = [];

  BreadcrumbList: any = [];

  PaginationDetail = {
    amount: 0,
    current: 1,
    size: 100,
  };

  BreadcrumbDefault = [
    {
      username: this.AuthInstance.user.username,
      source: this.AuthInstance.user.source,
      role: this.AuthInstance.user.role,
      userId: this.AuthInstance.user._id,
    },
  ];

  type = '';

  WinLoseList: any = {};

  resultData: any = {};

  LoginName = '';

  TableHeadMember = [...WinLoseData.TableHeadMember];

  TableHeadSubAgent = [...WinLoseData.TableHeadSubAgent];

  FilteredTableHeadMember: Array<object> = [...WinLoseData.TableHeadMember];

  TableHeadLog: any = [];

  mode = 'agent';

  dataKey = 'users';

  isMember = false;

  isSubAgent = false;

  detailFooterCol = 0;

  totalLog = 0;

  summaryLog = 0;

  houseEdge = [];

  totalCurrency: any = [];

  startDate = '';

  endDate = '';

  isToggleAction = false;

  durationTime = '';

  isRangeDate = false;

  currentCurrency = 'All'

  currencyList: string[] = [];

  ratioCurrency = ['MMK', 'IDR', 'VND', 'KHR', 'KRW', 'LAK', 'COP', 'TZS'];

  momentFormat = {
    stringify: (date) => this.$moment(date).format('DD-MM-YYYY'),
    parse: (value) => this.$moment(value).format('DD-MM-YYYY'),
  };

  created() {
    this.fetchNewWinlose();
    this.fetchPattern();
  }

  @Watch('Period.start.date', { immediate: true, deep: true })
  watchPeriodStart() {
    const _startDate = this.$moment(this.Period.start.date)
      .startOf('day')
      .toDate();
    this.startDate = _startDate;
  }

  @Watch('Period.end.date', { immediate: true, deep: true })
  watchPeriodEnd() {
    const _endDate = this.$moment(this.Period.end.date).endOf('day').toDate();
    this.endDate = _endDate;
  }

  initial() {
    this.currentTool = 'Today';
    this.Criteria = {
      ...this.Period,
      isSearch: false,
      gameName: ['total'],
      products: ['total'],
      role: this.AuthInstance.user.role,
      userId: this.AuthInstance.user._id,
      username: this.AuthInstance.user.username,
      source: this.AuthInstance.user.source,
      id: this.AuthInstance.user._id,
      sort: 'turnover',
    };
    this.LoginName = '';
    this.isMember = false;
  }

  handleSubmit() {
    this.Period.start.date = this.startDate;
    this.Period.end.date = this.endDate;
    this.fetchNewWinlose();
  }

  filterCurrency(item) {
    this.currentCurrency = item;
    this.currencyList = item === 'All' ? [...this.totalCurrency] : [item];
  }

  handlePatternType({ target: { checked, value } }) {
    if (value === 'total') {
      this.Criteria.gameName = checked
        ? this.PatternList.map((item) => item.value)
        : [];
    } else if (value !== 'total') {
      if (checked) {
        this.Criteria.gameName.push(value);
        if (this.Criteria.gameName.length === this.PatternList.length - 1) {
          this.Criteria.gameName.push('total');
        }
      } else {
        this.Criteria.gameName = this.Criteria.gameName.filter(
          (item) => item !== value && item !== 'total',
        );
      }
    }
    this.PaginationDetail = {
      current: 1,
      amount: 0,
      size: 100,
    };
    this.fetchNewWinlose();
  }

  selectSort(item) {
    if (this.Criteria.sort === item) return false;
    this.Criteria.sort = item;
    this.fetchNewWinlose();
  }

  async fetchNewWinlose() {
    let res;
    this.Criteria.isSearch = !!this.LoginName;
    const criteria = {
      ...this.Criteria,
      ...this.Period,
      ...this.PaginationDetail,
      time: this.durationTime,
    };
    this.GeneralInstance.toggleLoading(true);
    if (this.isMember && !this.durationTime) {
      res = await this.ReportInstance.FetchWinLoseRangeLogMechanic(criteria);
      if (res.code) {
        this.checkError(res);
        return false;
      }
      if (typeof res === 'object' && res.users) {
        this.resultData = res;
        this.isRangeDate = false;
        this.GeneralInstance.toggleLoading(false);
        this.TableHeadLog = [...WinLoseData.TableHeadDateRange];
        this.type = this.isMember ? 'dataWinLoseLog' : 'dataWinLose';
        this.mode = this.isMember ? 'member' : 'agent';
        this.WinLoseList = { ...this.ReportInstance[this.type] };
      } else {
        this.totalLog = 0;
        this.summaryLog = 0;
      }
    } else if (this.isMember && this.durationTime) {
      if (!criteria.products.includes('khm_company_total')) {
        criteria.products = criteria.gameName;
      }
      criteria.role = 'MEMBER';
      res = await this.ReportInstance.FetchWinloseLogElasticMechanic(criteria);
      if (res.code) {
        this.GeneralInstance.toggleLoading(false);
      }
      this.isRangeDate = true;
      this.resultData = { ...res.reportLog };
      this.BreadcrumbList = [...this.BreadcrumbDefault, ...res.breadcrumb];
      this.totalLog = res.reportCount;
      this.summaryLog = res.footerSummary;
      this.PaginationDetail = { ...res.paginationDetail };

      if (res) {
        this.TableHeadLog = [...WinLoseData.TableHeadLog];
        this.TableHeadLog[1] = [...WinLoseData.TableHeadLog[1]];
        const header = this.ReportInstance.dataNewWinLoseLog.reportLog.length
          ? this.ReportInstance.dataNewWinLoseLog.reportLog[0].each
          : [];
        const filterAgent = header.slice(1, header.length - 2);
        const loopTable = WinLoseData.TableHeadLog[1][1];
        const newTable = [];
        filterAgent.forEach(() => newTable.push(loopTable));
        const ownTable = [
          WinLoseData.TableHeadLog[1][0],
          ...newTable.map((v: any, i: number) => ({
            ...v,
            index: newTable.length - i,
          })),
          WinLoseData.TableHeadLog[1][2],
          WinLoseData.TableHeadLog[1][3],
        ];
        this.TableHeadLog[1] = ownTable;
        this.detailFooterCol = header.length;
      } else {
        this.totalLog = 0;
        this.summaryLog = 0;
      }
      this.type = this.isMember ? 'dataNewWinLoseLog' : 'dataWinLose';
      this.dataKey = this.isMember ? 'reportLog' : 'report';
      this.mode = this.isMember
        ? 'member'
        : this.isSubAgent
          ? 'subAgent'
          : 'agent';
      this.WinLoseList = { ...this.ReportInstance[this.type] };
      if (res.code) {
        this.checkError(res);
        this.GeneralInstance.toggleLoading(false);
      }
      this.GeneralInstance.toggleLoading(false);
    } else {
      // Trigger new report
      const { data, status } = await this.ReportInstance.FetchNewWinLoseMechanic(criteria);
      if (status) {
        this.checkError(status);
        this.GeneralInstance.toggleLoading(false);
      }
      if (
        ['COMPANY', 'SUPERADMIN', 'SUBCOMPANY'].includes(
          this.Criteria.role && this.AuthInstance.role,
        )
      ) {
        this.FilteredTableHeadMember[0] = [
          ...WinLoseData.TableHeadMember[0],
        ].filter((item: any) => !item.isCompanyHidden);
      } else {
        this.FilteredTableHeadMember = [...WinLoseData.TableHeadMember];
        this.FilteredTableHeadMember[0] = [
          ...WinLoseData.TableHeadMember[0],
        ].filter((item: any) => !item.isAnyHidden);
      }
      if (data.footerSummary.length) {
        this.resultData.footerSummary = data.footerSummary;
      } else this.resultData.footerSummary = [];

      this.houseEdge = this.resultData.footerSummary.map((item: any) => ({
        houseEdge: (item.rawWinlose / item.turnover) * -100,
        currency: item.currency,
      })) || 0;
      this.type = 'dataWinLose';
      this.dataKey = 'users';
      this.mode = 'agent';

      this.BreadcrumbList = [...this.BreadcrumbDefault, ...data.breadcrumb];
      this.PaginationDetail.amount = data.pageAmount;
      this.resultData = data;
      this.totalCurrency = data.users
        .filter((item) => item.report.length)
        .map((item) => item.currency);
      this.currencyList = [...this.totalCurrency];
      this.GeneralInstance.toggleLoading(false);
    }
  }

  async fetchResult(params) {
    const {
      roundId,
      product,
      category,
      prefix,
    } = params;
    const width = (category === 'arcade' && product !== 'PUNPAE')
    || product === 'BINGO'
    || product === 'BINGO2'
      ? 1305
      : 700;
    const height = category === 'arcade' || product === 'BINGO' || product === 'BINGO2'
      ? 630
      : 750;
    const strWindowFeatures = `top=0,left=0,height=${height},width=${width},scrollbars=yes`;
    const param = {
      roundId,
      prefix,
      language: this.$i18n.locale,
    };
    const res = await this.ReportInstance.FetchTransaction(param);
    window.open(res.url, 'gameResult', strWindowFeatures);
  }

  async fetchPattern() {
    const res = await this.MechanicInstance.FetchPatternList();
    if (res.code) {
      await this.checkError(res);
    } else {
      const arr = res
        .filter(({ status }) => status !== 999)
        .map(({ code, refPrefix }) => ({ name: refPrefix, value: code }));
      this.PatternList = [...this.DefaultPatternList, ...arr];
      this.Criteria.gameName = this.PatternList.map((item) => item.value);
    }
  }

  @Watch('$i18n.locale')
  onLanguagChange() {
    if (this.$i18n.locale) {
      this.mapGameInput();
    }
  }

  @Watch('isMember')
  onWatchisMember(fact) {
    if (fact) this.Criteria.role = this.AuthInstance.user.role;
  }

  handleSearch() {
    this.PaginationDetail.current = 1;
    this.Criteria.username = this.LoginName;
    this.isMember = this.AuthInstance.user.role === 'ADMIN';
    this.Criteria.username = this.LoginName
      ? this.LoginName
      : this.AuthInstance.user.username;
  }

  handleFetchWinloseAgent(username, role, source, id) {
    this.PaginationDetail.current = 1;
    this.PaginationDetail.amount = 1;
    this.durationTime = '';
    this.beforeFetch(username, role, source, id, this.durationTime);
  }

  handleBreadcrumb({
    username, role, source, id,
  }) {
    this.PaginationDetail.current = 1;
    this.PaginationDetail.amount = 1;
    this.durationTime = '';
    this.beforeFetch(
      username,
      role,
      source,
      id,
      this.durationTime,
    );
  }

  beforeFetch(username, role, source, id, durationTime) {
    this.isMember = role === 'MEMBER';
    this.isSubAgent = role === 'AGENT';
    this.LoginName = '';
    this.Criteria.username = username;
    this.Criteria.source = source;
    this.Criteria.role = role;
    this.Criteria.id = id;
    this.durationTime = durationTime;
    this.fetchNewWinlose();
  }

  handleTimeRange(username, role, source, id, durationTime) {
    this.beforeFetch(username, role, source, id, durationTime);
  }

  changePage(i) {
    this.PaginationDetail.current = i;
    this.fetchNewWinlose();
  }

  changeDate(Tool) {
    this.durationTime = '';
    this.handleTool(Tool.key);
  }

  onSubmit() {
    this.fetchNewWinlose();
  }
}
